import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.travelReportFilter.optionsItems.shadow};
  margin-top: 1px;
  background: ${({ theme }) => theme.travelReportFilter.optionsItems.background};
`;

export const HiddenSearchInput = styled.input`
  opacity: 0;
  height: 0 !important;
  position: absolute;
  z-index: -1;
`;

export const NoResults = styled.span`
  font-size: 16px;
  padding: 21px 16px;
`;

export const Items = styled.ul`
  padding: 0;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;

  font-size: 16px;
  padding: 21px 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.travelReportFilter.optionsItems.primary};
  border-bottom: 1px solid ${({ theme }) => theme.travelReportFilter.optionsItems.line};
  background: ${({ theme }) => theme.travelReportFilter.optionsItems.background};

  &.active {
    background-color: ${({ theme }) => theme.travelReportFilter.optionsItems.activeBackground};
  }

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: ${ColorPalette.HEX.FloralWhite};
  }
`;

export const ItemCode = styled.span`
  margin-right: 16px;
  width: 50px;
  text-align: right;
`;
